<script>
export default {
  computed: {
    list() {
      return () => import(`@/components/Themes/${this.$cookies.get('theme') ?? 'default'}/Loyalty/Reward/List`);
    }
  },
  methods: {},
};
</script>
<template>
  <component :is="list" v-if="list"></component>
</template>